import React from 'react';
import warningIMG from '@/assets/imgs/icons/warning.svg';
import { Button, Image } from '@/components/generic';

export const WarningStatus = ({
  content,
  onClose,
  confirm,
}: {
  content?: string | React.ReactNode;
  onClose?: () => void;
  confirm?: () => void;
}) => {
  return (
    <>
      <div className='flex justify-center items-center size-16 mb-8 bg-primary-03/15 rounded-full'>
        <Image className='size-6 opacity-100' src={warningIMG} alt='' />
      </div>
      <div className='mb-4 text-h4 max-md:text-h5 text-t-primary'>
        Are you sure?
      </div>
      <div className='mb-8 text-body-2 font-medium text-t-tertiary'>
        {content}
      </div>
      <div className='flex justify-end gap-3 mt-8'>
        <Button className='flex-1' isStroke onClick={onClose}>
          Cancel
        </Button>
        <Button className='flex-1' isBlack onClick={confirm}>
          Confirm
        </Button>
      </div>
    </>
  );
};
